import { defineStore } from 'pinia';
import { staticHolidays } from '../constants/staticHolidays';
import { fetchHolidays } from '../dataProviders/holidays';

export const useHolidaysStore = defineStore('holidays', () => {
  const holidays = ref(staticHolidays);
  const holidaysFetched = ref(false);
  const loadHolidays = () => {
    if (holidaysFetched.value)
      return;
    fetchHolidays().then((res) => {
      if (res?.length) {
        holidays.value = res;
        holidaysFetched.value = true;
      }
    });
  };
  return {
    holidays,
    loadHolidays,
  };
});
